import React, { useState } from 'react';
import { ChevronDown, ChevronUp, CheckCircle } from 'lucide-react';
const faqs = [{
  q: '¿Qué incluye el 4x1 de casos reales?',
  a: 'Recibes 4 expedientes digitales completos: fotos de la escena, cartas entre sospechosos, documentos confidenciales, recibos bancarios, informes de autopsia y más. Todo en formato PDF descargable, listo para jugar en cualquier dispositivo.'
}, {
  q: '¿Cómo recibo los archivos y cuánto tardan?',
  a: 'Recibes todo directamente en tu correo electrónico en menos de 5 minutos tras la compra. Sin esperas, sin envíos físicos. Acceso inmediato garantizado.'
}, {
  q: '¿Para cuántas personas es y cuánto dura cada caso?',
  a: 'Puedes jugar solo, en pareja o en grupo. No hay límite de participantes. Cada caso dura entre 1 y 3 horas dependiendo de tu ritmo y nivel de detalle con el que investigues.'
}, {
  q: '¿Necesito imprimir algo o puedo jugar digital?',
  a: '100% digital. Puedes jugar directamente desde tu móvil, tablet u ordenador. No necesitas imprimir nada, aunque si prefieres, puedes hacerlo para una experiencia más inmersiva.'
}, {
  q: '¿Qué nivel de dificultad tienen y para qué edades?',
  a: 'Nivel medio-alto. Recomendado para mayores de 14 años. Las pistas son lógicas pero requieren atención al detalle y trabajo en equipo. Perfectos para grupos que disfrutan de los retos.'
}, {
  q: '¿Tienen garantía o reembolso?',
  a: 'Sí. Ofrecemos garantía de satisfacción de 30 días. Si no estás satisfecho con tu compra, te devolvemos el dinero sin preguntas. Tu satisfacción es nuestra prioridad.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 px-4" style={{
    backgroundColor: '#0a0a0a'
  }} data-id="element-84">
      <div className="w-full mb-6" style={{
      height: '2px',
      background: 'linear-gradient(90deg, transparent, #c0392b, transparent)'
    }} data-id="element-85" />

      <div className="max-w-2xl mx-auto" data-id="element-86">
        <h2 className="text-center text-2xl sm:text-3xl font-bold text-white mb-2" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-87">
          Preguntas Frecuentes
        </h2>
        <p className="text-center text-gray-500 text-sm mb-6" data-id="element-88">
          Todo lo que necesitas saber antes de convertirte en detective
        </p>

        <div className="flex flex-col gap-3" data-id="element-89">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="rounded-lg overflow-hidden transition-all" style={{
            backgroundColor: '#111111',
            border: `1px solid ${isOpen ? '#c0392b' : '#222'}`
          }} data-id="element-90">
                <button className="w-full flex items-center gap-3 p-4 text-left transition-colors" style={{
              backgroundColor: isOpen ? 'rgba(192,57,43,0.08)' : 'transparent'
            }} onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-91">
                  <CheckCircle size={18} style={{
                color: '#27ae60',
                flexShrink: 0
              }} data-id="element-92" />
                  <span className="text-white font-semibold text-sm flex-1 leading-snug" data-id="element-93">
                    {faq.q}
                  </span>
                  {isOpen ? <ChevronUp size={18} style={{
                color: '#c0392b',
                flexShrink: 0
              }} data-id="element-94" /> : <ChevronDown size={18} style={{
                color: '#666',
                flexShrink: 0
              }} data-id="element-95" />}
                </button>

                {isOpen && <div className="px-4 pb-4 pt-0" style={{
              borderTop: '1px solid rgba(192,57,43,0.2)'
            }} data-id="element-96">
                    <p className="text-gray-400 text-sm leading-relaxed pt-3 pl-7" data-id="element-97">
                      {faq.a}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>

      <div className="w-full mt-6" style={{
      height: '2px',
      background: 'linear-gradient(90deg, transparent, #c0392b, transparent)'
    }} data-id="element-98" />
    </section>;
}